import $ from 'jquery';
import IMask from 'imask';
import moment from 'moment';
import Validation from '../../common/utils/validation';


class RequestQuote {
    constructor() {
        this.agents = [];
        this.isValid = true;
        this.errors = [];
        this.isClient = undefined;
        this.agentId = undefined;
        this.scrollToElement = undefined;
        this.scrollToOffset = $('header').height();
        this.isAgentCookied = false;
        this.validServiceStates = ['AZ', 'IA', 'ID', 'KS', 'MN', 'MT', 'ND', 'NE', 'NM', 'OK', 'SD', 'UT', 'WI', 'WY'];
        this.$agentTrayContent = $('.agent-tray-content');
        this.$agentTrayClose = $('.agent-tray-close');
        this.data = {};
        this.textIds = ['#Form_Email', '#Form_Address1', '#Form_Zipcode', '#Form_FirstName', '#Form_LastName', '#Form_Birthdate', '#Form_Address2', '#Form_City', '#Form_StateCode', '#Form_Message', '#Form_PhoneNumber'];
    }

    init() {
        if ($('.js-request-quote-form').length) {
            this.setupPhoneMask();
            this.setupDobMask();
        }

        this.isAgentCookiedCheck();
        this.agentTreyStickyness();
        this.bindEvents();
    }


    bindEvents() {
        // Gets the cookie by name
        function getCookie(name) {
          const value = `; ${document.cookie}`;
          const parts = value.split(`; ${name}=`);
          if (parts.length === 2) return parts.pop().split(';').shift();
          return '';
        }
        // returns the data as an object
        function retrieveData() {
            const jsonData = getCookie('RequestAQuoteInformation');
            // Parse the JSON data back into a JavaScript object
            if (jsonData) {
                const parsedData = JSON.parse(jsonData);
                return parsedData;
                // Do something with the data
            } else {
                return {};
            }
        }

        $(document).ready(() => {
            this.data = retrieveData();
            this.textIds.forEach((name) => {
                $(name).val(this.data[name]);
            });
            $('input[type=checkbox], input[type="radio"]').each((checked) => {
                let element = $('input[type=checkbox], input[type="radio"]')[checked];
                let id = element.getAttribute('id');
                const hasKey = Object.keys(this.data).includes(id);
                if (hasKey) {
                    element.checked = true;
                }
            });
            if ($('#Form_IsClient_False').is(':checked')) {
                $('.js-conditional-field').fadeIn(250);
            }
        });

        // Set Cookie saving fields information
        window.addEventListener('beforeunload', (e) => {
            let newCookie = {};
            this.textIds.forEach((name) => {
                newCookie[name] = document.querySelector(name).value;
            });
            $('input:checked').each((checked) => {
                let id = $('input:checked')[checked].getAttribute('id');
                newCookie[id] = id;
            });
            document.cookie = `RequestAQuoteInformation=${JSON.stringify(newCookie || '')}`;
        });

        // New client radio
        $('input[name="Form.IsClient"]').on('change', (e) => {
            let answer = $(e.currentTarget).val();
            this.isClient = answer;

            if (answer === 'True') {
                $('.js-conditional-field').fadeOut(250);
            } else {
                $('.js-conditional-field').fadeIn(250);
            }
            this.validateIsClient();
        });
        //---/ New client radio


        // Submit
        $('.js-submit').on('click', (e) => {
            e.preventDefault();

            if (this.validateForm()) {
                document.cookie = `RequestAQuoteInformation=${''}`;
                grecaptcha.ready(() => {
                    // Action matches the data-action attribute on the HTML button element that is clicked/entered to submit
                    grecaptcha.execute($('g-recaptcha').data('sitekey'), { action: 'quoteSubmit' }).then((token) => {
                        $('.js-submit').addClass('disabled');
                        $('.js-submit').css('pointer-events', 'none');
                        $('form.form--request-quote').submit();
                    });
                });
            }
        });
        //---/ Submit

        // Privacy Modal
        $('.js-privacy').on('click', (e) => {
            e.preventDefault();

            $('.js-privacy').modaal({
                content_source: '#privacy-information',
                start_open: true,
                overlay_opacity: 0.6
            });
        });

        $('.js-privacy').on('keydown', (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') {
                return;
            }
            event.preventDefault();

            $('.js-privacy').modaal({
                content_source: '#privacy-information',
                start_open: true,
                overlay_opacity: 0.6
            });
        });
        //---/ Privacy Modal

        // Agent Tray
        $('.js-agent-tray').on('click', (e) => {
            $('.js-agent-tray-content, .js-agent-tray-overlay').css({ opacity: '0', display: 'block' }).show(500).animate({ opacity: 1 });
        });

        $('.js-agent-tray').on('keydown', (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') {
                return;
            }
            event.preventDefault();

            $('.js-agent-tray-content, .js-agent-tray-overlay').css({ opacity: '0', display: 'block' }).show(500).animate({ opacity: 1 });
        });

        $('.js-agent-tray-close').on('click', (e) => {
            $('.js-agent-tray-content, .js-agent-tray-overlay').fadeOut(500);
        });

        $(window).resize(e => {
            this.agentTreyStickyness();
        });
        //---/ Agent Tray

        // Fields OnBlur
        $('#Form_FirstName').on('change keyup', () => this.validateFirstName());
        $('#Form_LastName').on('change keyup', () => this.validateLastName());
        $('#Form_Email').on('change keyup', () => this.validateEmail());
        $('#Form_Address1').on('change keyup', () => this.validateAddress());
        $('#Form_City').on('change keyup', () => this.validateCity());
        $('#Form_StateCode').on('change keyup', () => this.validateState());
        $('#Form_Zipcode').on('change keyup', () => this.validateZipCode());
        $('.js-checkbox-list input[type=checkbox]').on('change', () => this.validateServices());
        //---/ Fields OnBlur
    }

    agentTreyStickyness() {
        let headerHeight = $('.header').outerHeight();

        this.$agentTrayContent.css('margin-top', headerHeight);
        this.$agentTrayClose.css('margin-top', headerHeight);
    }

    setupPhoneMask() {
        let phoneSelector = document.getElementById('Form_PhoneNumber');
        let maskOptions = {
            mask: '(000) 000-0000'
        };
        let mask = IMask(phoneSelector, maskOptions);
        mask.on('accept', () => { this.validatePhone(); });
        mask.on('complete', () => { this.validatePhone(); });

        $(phoneSelector).attr('placeholder', '(___) ___-____');
    }

    setupDobMask() {
        let dobSelector = document.getElementById('Form_Birthdate');
        let maskOptions = {
            mask: '00/00/0000'
        };
        let mask = IMask(dobSelector, maskOptions);
        mask.on('accept', () => { this.validateDateOfBirth(); });
        mask.on('complete', () => { this.validateDateOfBirth(); });

        $(dobSelector).attr('placeholder', 'mm/dd/yyyy');
    }

    isAgentCookiedCheck() {
        if ($('.is-current-agent').hasClass('no-agent')) {
            this.isAgentCookied = false;
        } else {
            this.isAgentCookied = true;
        }
    }

    isServiceAvailableinState(elem) {
        let stateCode = elem.val();
        return this.validServiceStates.includes(stateCode);
    }

    scrollToError() {
        this.scrollToElement = this.errors[0]; // eslint-disable-line
        if (this.scrollToElement !== undefined || this.scrollToOffset !== undefined) {
            $('html, body').animate({ scrollTop: $(this.scrollToElement).offset().top - this.scrollToOffset }, 750);
        }
    }

    validateIsClient() {
        if (this.isClient === undefined) {
            $('input[name="Form.IsClient"]').closest('.form-group').addClass('form-error');
            this.isValid = false;
            this.errors.push('.form-is-client');
            $('#Form_IsClient_True').attr('aria-invalid', 'true');
            $('#Form_IsClient_False').attr('aria-invalid', 'true');
            $('#Form_IsClient_True').prop('required', true);
            $('#Form_IsClient_False').prop('required', true);
        } else {
            $('input[name="Form.IsClient"]').closest('.form-group').removeClass('form-error');
            $('#Form_IsClient_True').attr('aria-invalid', 'false');
            $('#Form_IsClient_False').attr('aria-invalid', 'false');
            $('#Form_IsClient_True').prop('required', false);
            $('#Form_IsClient_False').prop('required', false);
        }
    }

    validateTextInput(elem, id) {
        if (elem.val() === '') {
            elem.closest('.form-group').addClass('form-error');
            this.isValid = false;
            this.errors.push(id);
            $(id).attr('aria-invalid', 'true');
        } else {
            elem.closest('.form-group').removeClass('form-error');
            $(id).attr('aria-invalid', 'false');
        }
        // Dynamic validation on all text inputs
        // $('.js-validate-text input:visible').each((i, e) => {
        //     let $textbox = $(e);

        //     if ($textbox.val() === '') {
        //         $textbox.closest('.form-group').addClass('form-error');
        //         this.isValid = false;
        //     }
        //     else {
        //         $textbox.closest('.form-group').removeClass('form-error');
        //         this.isValid = true;
        //     }
        // });
    }

    validateFirstName() {
        let id = '#Form_FirstName';
        let elem = $('#Form_FirstName');

        this.validateTextInput(elem, id);
    }

    validateLastName() {
        let id = '#Form_LastName';
        let elem = $('#Form_LastName');

        this.validateTextInput(elem, id);
    }

    validateAddress() {
        let id = '#Form_Address1';
        let elem = $('#Form_Address1');

        this.validateTextInput(elem, id);
    }

    validateCity() {
        let id = '#Form_City';
        let elem = $('#Form_City');

        this.validateTextInput(elem, id);
    }

    validateEmail() {
        if (Validation.emailValidate($('#Form_Email'))) {
            $('.js-validate-email').removeClass('form-error');
            $('#Form_Email').attr('aria-invalid', 'false');
        } else {
            $('.js-validate-email').addClass('form-error');
            this.isValid = false;
            this.errors.push('#Form_Email');
            $('#Form_Email').attr('aria-invalid', 'true');
        }
    }

    validatePhone() {
        if (Validation.phoneValidate($('#Form_PhoneNumber'))) {
            $('.js-validate-phone').removeClass('form-error');
            $('#Form_PhoneNumber').attr('aria-invalid', 'false');
        } else {
            $('.js-validate-phone').addClass('form-error');
            this.isValid = false;
            this.errors.push('#Form_PhoneNumber');
            $('#Form_PhoneNumber').attr('aria-invalid', 'true');
        }
    }

    validateZipCode() {
        if (Validation.zipValidate($('#Form_Zipcode'))) {
            $('.js-validate-zip').removeClass('form-error');
            $('#Form_Zipcode').attr('aria-invalid', 'false');
        } else {
            $('.js-validate-zip').addClass('form-error');
            this.isValid = false;
            this.errors.push('#Form_Zipcode');
            $('#Form_Zipcode').attr('aria-invalid', 'true');
        }
    }

    validateServices() {
        if ($('.js-checkbox-list input[type=checkbox]:checked').length) {
            $('.js-service-input').attr('aria-invalid', 'false');
            $('.js-service-input').prop('required', false);
            $('.js-checkbox-list').removeClass('form-error');
        } else {
            $('.js-service-input').attr('aria-invalid', 'true');
            $('.js-service-input').prop('required', true);
            $('.js-checkbox-list').addClass('form-error');
            this.isValid = false;
            this.errors.push('.js-checkbox-list');
        }
    }

    validateDateOfBirth() {
        if (moment($('#Form_Birthdate').val(), 'MM/DD/YYYY', true).isValid()) {
            $('.js-validate-date').removeClass('form-error');
            $('.js-validate-date').removeClass('secondary-form-error');
            $('#Form_Birthdate').attr('aria-invalid', 'false');
        } else if ($('#Form_Birthdate').val() === '') {
            $('.js-validate-date').removeClass('form-error');
            $('.js-validate-date').addClass('secondary-form-error');
            $('#Form_Birthdate').attr('aria-invalid', 'true');
            this.isValid = false;
            this.errors.push('.js-validate-date');
        } else {
            $('.js-validate-date').addClass('form-error');
            $('.js-validate-date').removeClass('secondary-form-error');
            $('#Form_Birthdate').attr('aria-invalid', 'true');
            this.isValid = false;
            this.errors.push('.js-validate-date');
        }
    }

    validateState() {
        if (Validation.selectValidate($('#Form_StateCode')) && this.isServiceAvailableinState($('#Form_StateCode'))) {
            $('.js-validate-select').removeClass('form-error');
            $('.js-validate-select').removeClass('secondary-form-error');
            $('#Form_StateCode').attr('aria-invalid', 'false');
        } else if (Validation.selectValidate($('#Form_StateCode')) && !this.isServiceAvailableinState($('#Form_StateCode'))) {
            $('.js-validate-select').removeClass('form-error');
            $('.js-validate-select').addClass('secondary-form-error');
            $('#Form_StateCode').attr('aria-invalid', 'true');
            this.isValid = false;
            this.errors.push('.js-validate-select');
        } else {
            $('.js-validate-select').addClass('form-error');
            $('.js-validate-select').removeClass('secondary-form-error');
            $('#Form_StateCode').attr('aria-invalid', 'true');
            this.isValid = false;
            this.errors.push('.js-validate-select');
        }
    }

    validateAgentId() {
        this.agentId = $('input[name="Form.AgentId"]:checked').val();

        if (this.agentId === undefined) {
            $('.js-validate-agent-id').addClass('form-error');
            this.isValid = false;
            this.errors.push('#request-quote-app');
        } else {
            $('.js-validate-agent-id').removeClass('form-error');
        }
    }

    validateForm() {
        this.isClient = $('input[name="Form.IsClient"]:checked').val();
        this.isValid = true;
        this.errors = [];
        // Is Client Radio
        this.validateIsClient();
        //--/ Is Client Radio

        // Name Input Textboxes
        this.validateFirstName();
        this.validateLastName();
        //---/ Input Textboxes

        // Email Address
        this.validateEmail();
        //---/ Email Address

        // Phone Number
        this.validatePhone();
        //---/ Phone Number

        // Validate client dependent fields
        if (this.isClient === 'False') {
            // Date
            this.validateDateOfBirth();
            //---/ Date

            // Address
            this.validateAddress();
            //---/ Address

            // City
            this.validateCity();
            //---/ City

            // State
            this.validateState();
            //---/ State
        }
        //---/ Validate client dependent fields

        // Zip Code
        this.validateZipCode();
        //---/ Zip Code

        // Validate Agent depends on AgentId cookie
        if (!this.isAgentCookied) {
            this.validateAgentId();
        }
        //---/ Validate Agent depends on AgentId cookie

        // Services
        this.validateServices();
        //---/ Services

        //---/ reCaptcha

        if ((this.isValid !== true) && (this.errors.length)) {
            this.scrollToError();
            let invalidInputs = $('input[aria-invalid="true"], select[aria-invalid="true"]');
            if (invalidInputs.length > 0) {
                invalidInputs[0].focus();
            }
        }

        return this.isValid;
    }
}

export default RequestQuote;

$(() => {
    const requestQuote = new RequestQuote();
    requestQuote.init();
});